import { render, staticRenderFns } from "./WheelLockSettings.vue?vue&type=template&id=70aeab73&"
import script from "./WheelLockSettings.vue?vue&type=script&lang=js&"
export * from "./WheelLockSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports